module.exports = {
    "title": "MedDRA",
    "entityName": "meddra",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "llt_code",
            "text": "LLT Code",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "llt_name",
            "text": "LLT Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },
        {
            "value": "pt_code",
            "text": "PT Code",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "pt_name",
            "text": "PT Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            render: (item) => {
                return item.PREF_TERM.pt_name
            },
            filter: (item, search) => [{ 'PREF_TERM.pt_name': `%${search}%`}],
        },

        {
            "value": "soc_code",
            "text": "SOC Code",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            render: (item) => {
                return item.SOC_TERM.soc_code
            },
            filter: (item, search) => [{ 'SOC_TERM.soc_code': `%${search}%`}],
        },

        {
            "value": "soc_name",
            "text": "SOC Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
            render: (item) => {
                return item.SOC_TERM.soc_name
            },
            filter: (item, search) => [{ 'SOC_TERM.soc_name': `%${search}%`}],
        },


    ],
    "actions": [
    ]
}